import React from 'react';
import ClaimCard from 'components/containers/claims/entity/ClaimCard';

export default function ClaimWrapper({ data }) {
  return <ClaimCard data={data} />;
}
